/** TR01 copy (one group per control; a ticket edits only its own file). */
export const tr01PtBr = {
  title: 'Extratos completos e em dia',
  description: 'Cada conta esperada tem extrato até a data de corte, na frequência da sua fonte.',
  prerequisite:
    'Requer o inventário declarado de contas e fontes de extrato por entidade e data de vigência.',
  diagnosticLabel: 'Atualização das contas conhecidas',
  reasons: {
    STATEMENT_STALE: 'Integração diária atrasada (mais de 2 dias úteis)',
    STATEMENT_BALANCE_MISSING: 'Conta movimentada sem saldo de extrato na data de corte',
    SOURCE_SILENT: 'Sem movimento e sem saldo: fonte silenciosa, não saldo zero',
  },
  observations: {
    TR01_KNOWN_ACCOUNTS: 'Contas conhecidas avaliadas: {{count}}',
    TR01_RESTRICTED_ACCOUNTS: 'Contas com acesso restrito, contadas sem detalhes: {{count}}',
  },
};

export const tr01En: typeof tr01PtBr = {
  title: 'Complete and current statements',
  description: 'Every expected account has a statement up to the cutoff, at its source frequency.',
  prerequisite:
    'Needs the declared inventory of accounts and statement sources by entity and effective date.',
  diagnosticLabel: 'Freshness of known accounts',
  reasons: {
    STATEMENT_STALE: 'Daily integration behind (more than 2 business days)',
    STATEMENT_BALANCE_MISSING: 'Account with movements and no statement balance at the cutoff',
    SOURCE_SILENT: 'No movement and no balance: a silent source, not a zero balance',
  },
  observations: {
    TR01_KNOWN_ACCOUNTS: 'Known accounts evaluated: {{count}}',
    TR01_RESTRICTED_ACCOUNTS: 'Restricted-access accounts, counted without details: {{count}}',
  },
};
